import React, { useEffect, useState, useCallback } from "react";
import { Link } from "react-router-dom";
import {
  Card,
  CardBody,
  Col,
  Container,
  Row,
  Modal,
  ModalHeader,
  ModalBody,
  Label,
  FormFeedback,
  Input,
  Form,
  Button,
  Table,
} from "reactstrap";
import * as Yup from "yup";
import { useFormik } from "formik";
//redux
import { useSelector, useDispatch } from "react-redux";

import withRouter from "../../Components/Common/withRouter";

//Import Breadcrumb
import Breadcrumbs from "../../Components/Common/Breadcrumb";
import DeleteModal from "../../Components/Common/DeleteModal";

import { deleteUsers as onDeleteUsers } from "slices/roles/thunk";
import Spinners from "Components/Common/Spinner";
import { ToastContainer } from "react-toastify";
import { setAuthorization } from "../../helpers/api_helper";
import {
  getCountries,
  getGenders,
  getRolesByEntity,
  getUsersByEntity,
} from "../../helpers/dataBackend";
import {
  addNewUser,
  deleteUsers,
  updateUserRole,
} from "slices/user-system/thunk";
import { RootState } from "slices";
import { decryptState } from "shared/encryptInfo";
import Select from "react-select";
import { PermissionWrapper } from "shared/permissionWrapper";

const UserSystem = () => {
  //meta title
  document.title = "User List";
  const dispatch = useDispatch<any>();

  const users = useSelector((state: RootState) => state.UserSystem.users);
  const loading = useSelector((state: RootState) => state.UserSystem.loading);

  const [isLoading, setLoading] = useState<boolean>(loading);
  const [contact, setContact] = useState<any>();
  const [usersData, setUsersData] = useState<any>([]);
  const [userDataEdit, setUserDataEdit] = useState<any>({});

  //PAGIANCION
  // Estado para la página actual y cantidad de elementos por página
  const [currentPage, setCurrentPage] = useState(1);
  const [itemsPerPage, setItemsPerPage] = useState<number>(5); // Ajusta este número según lo que necesites
  // Cálculos para obtener los elementos de la página actual
  const indexOfLastItem = currentPage * itemsPerPage;
  const indexOfFirstItem = indexOfLastItem - itemsPerPage;
  const currentItems = usersData.slice(indexOfFirstItem, indexOfLastItem);
  const totalPages = Math.ceil(usersData.length / itemsPerPage);
  const [modal, setModal] = useState<boolean>(false);
  const [modalEdit, setModalEdit] = useState<boolean>(false);
  const [isEdit, setIsEdit] = useState<boolean>(false);

  const [countries, setCountries] = useState<any>([]);
  const [gendersType, setGendersType] = useState<any>([]);
  const [rolesData, setRolesData] = useState<any>([]);
  const [rolesDataEdit, setrolesDataEdit] = useState<any>([]);

  //PERMISOS
  const [selectedPermissions, setSelectedPermissions] = useState<any>([]);
  const options = rolesData
    .filter((permission) => permission.name !== "ENTITY_ROLE") // Filtra la opción no deseada
    .map((permission) => ({
      value: permission.id,
      label: permission.name,
    }));

  const handleChange = (selectedOptions) => {
    setSelectedPermissions(selectedOptions.map((option: any) => option.value));
  };

  const toggle = useCallback(() => {
    setModal(!modal);
  }, [modal]);
  const toggleEdit = useCallback(() => {
    setModalEdit(!modalEdit);
  }, [modalEdit]);

  const entidad: any = localStorage.getItem("userInfo");
  const decryptedData = decryptState(entidad);
  const entidad_id = decryptedData;
  // validation
  const validation: any = useFormik({
    // enableReinitialize : use this flag when initial values needs to be changed
    enableReinitialize: true,

    initialValues: {
      name: "",
      last_name: "",
      email: "",
      password: "",
      gender_id: "",
      country_id: "",
      roles: [],
    },
    validationSchema: Yup.object({
      name: Yup.string().required("Please Enter Name"),
      last_name: Yup.string().required("Please Enter Last Name"),
      email: Yup.string().required("Please Enter Email"),
      password: Yup.string().required("Please Enter Password"),
      gender_id: Yup.string().required("Please Enter Gender"),
      country_id: Yup.string().required().required("Please Enter Country"),
      roles: Yup.array().required().required("Please Enter Roles"),
    }),
    onSubmit: async (values: any) => {
      const newUser = {
        name: values.name,
        last_name: values.last_name,
        email: values.email,
        password: values.password,
        gender_id: parseInt(values.gender_id),
        country_id: parseInt(values.country_id),
        entity_id: entidad_id.entity_id,
        status_id: 1,
        roles: selectedPermissions,
      };
      // save new user
      // console.log(newUser);
      await dispatch(addNewUser(newUser));
      await getUsers(); // 🔄 Recarga la lista después de guardar
      validation.resetForm();
      toggle();
    },
  });

  //VALIDACION PARA ACTUALIZAR EL USUARIO CON LOS ROLES
  const validationEdit: any = useFormik({
    // enableReinitialize : use this flag when initial values needs to be changed
    enableReinitialize: true,

    initialValues: {
      name: (userDataEdit && userDataEdit.name) || "",
      last_name: (userDataEdit && userDataEdit.last_name) || "",
    },
    validationSchema: Yup.object({
      name: Yup.string().required("Please Enter Name"),
      last_name: Yup.string().required("Please Enter Last Name"),
    }),
    onSubmit: async (values: any) => {
      const updateUser = {
        id: userDataEdit.id,
        name: values.name,
        last_name: values.last_name,
        roles: selectedPermissions, // array de ids de rol
      };
      try {
        // 1) Llamas al thunk que actualiza en backend
        await dispatch(updateUserRole(updateUser));

        // 2) Actualizas sólo ese usuario en el estado local
        setUsersData((prev: any) =>
          prev.map((u: any) =>
            u.id === userDataEdit.id
              ? {
                  ...u,
                  name: values.name,
                  last_name: values.last_name,
                  // reconstruye user_roles usando la lista global de roles
                  user_roles: rolesData
                    .filter((r: any) => selectedPermissions.includes(r.id))
                    .map((r: any) => ({ id: r.id, name: r.name })),
                }
              : u
          )
        );

        // 3) Cierra modal y limpia flags
        validationEdit.resetForm();
        setIsEdit(false);
        toggleEdit();
      } catch (err) {
        console.error("Error actualizando roles:", err);
        // opcional: toast de error
      }
    },
  });

  const handleEditUser = (userId: number) => {
    const user = usersData.find((user: any) => user.id === userId);
    setUserDataEdit(user);
    setrolesDataEdit(user.user_roles);
    setIsEdit(true);
    setModalEdit(true);
  };

  async function getUsers() {
    const users = await getUsersByEntity();
    setUsersData(JSON.parse(users.data));
  }

  useEffect(() => {
    const fetchData = async () => {
      try {
        const token = localStorage.getItem("authUser");
        // console.log(token);
        setAuthorization(token); // Guardar el token antes de continuar

        getUsers();
        // Ahora que el token está listo, hacer las demás llamadas
        const countries = await getCountries();
        setCountries(JSON.parse(countries.data));
        const genders = await getGenders();
        setGendersType(JSON.parse(genders.data));
        const roles = await getRolesByEntity();
        setRolesData(JSON.parse(roles.data));
        setIsEdit(false);
      } catch (error) {
        console.error("Error al obtener datos:", error);
      }
    };

    fetchData();
  }, [dispatch]);

  useEffect(() => {
    setContact(users);
    setIsEdit(false);
  }, [users, usersData]);

  const [deleteModal, setDeleteModal] = useState<boolean>(false);

  const onClickDelete = async (id: any) => {
    try {
      // 1) Hacer toggle en backend
      await dispatch(deleteUsers(id));
      // 2) Refrescar localmente el array, invirtiendo is_active
      setUsersData((prev) =>
        prev.map((user) =>
          user.id === id ? { ...user, is_active: !user.is_active } : user
        )
      );
    } catch (err) {
      console.error("Error al cambiar estado de usuario:", err);
      // opcional: toast de error o revertir cambios si usas optimistic updates
    }
  };

  const handleDeleteUser = () => {
    dispatch(onDeleteUsers(contact));
    // onPaginationPageChange(1);
    setDeleteModal(false);
  };

  return (
    <React.Fragment>
      <DeleteModal
        show={deleteModal}
        onDeleteClick={handleDeleteUser}
        onCloseClick={() => setDeleteModal(false)}
      />
      <div className="page-content">
        <Container fluid>
          {/* Render Breadcrumbs */}
          <Breadcrumbs title="User" breadcrumbItem="User List" />
          <Row>
            <Col lg="12">
              {isLoading ? (
                <Spinners setLoading={setLoading} />
              ) : (
                <Card>
                  <CardBody>
                    <div className="mb-2 row">
                      <div className="col-sm-2">
                        <select
                          className="form-select pageSize mb-2"
                          onChange={(e) =>
                            setItemsPerPage(parseInt(e.target.value))
                          }
                        >
                          <option value="5">Show 5</option>
                          <option value="10">Show 10</option>
                          <option value="20">Show 20</option>
                          <option value="30">Show 30</option>
                          <option value="40">Show 40</option>
                        </select>
                      </div>
                      <div className="col-sm-4">
                        <input
                          className="form-control search-box me-2 mb-2 d-inline-block"
                          placeholder="Search..."
                          value=""
                        ></input>
                      </div>
                      <div className="col-sm-6">
                        <div className="text-sm-end">
                          <PermissionWrapper action="US0002">
                            <button
                              type="button"
                              className="btn btn-success btn-rounded waves-effect waves-light addContact-modal mb-2 btn btn-secondary"
                              onClick={() => {
                                setIsEdit(false);
                                setModal(true);
                              }}
                            >
                              <i className="mdi mdi-plus me-1"></i> New User
                            </button>
                          </PermissionWrapper>
                        </div>
                      </div>
                    </div>
                    <div className="table-responsive">
                      <Table className="table mb-0">
                        <thead className="table-light">
                          <tr>
                            <th>#</th>
                            <th>First Name</th>
                            <th>Last Name</th>
                            <th>Email</th>
                            <th>Activo</th>
                            <th>Roles</th>
                            <th>Action</th>
                          </tr>
                        </thead>
                        <tbody>
                          {/* users */}
                          {currentItems.map((item, index) => (
                            <tr key={item.id}>
                              <th scope="row">
                                {index + 1 + indexOfFirstItem}
                              </th>
                              <td>{item.name}</td>
                              <td>{item.last_name}</td>
                              <td>{item.email}</td>
                              <td>
                                {item.is_active ? (
                                  <p className="btn btn-success btn-rounded waves-effect waves-light addContact-modal mb-2 btn btn-secondary">
                                    True
                                  </p>
                                ) : (
                                  <p className="btn btn-danger btn-rounded waves-effect waves-light addContact-modal mb-2 btn btn-secondary">
                                    False
                                  </p>
                                )}
                              </td>
                              <td>
                                {item.user_roles.map((role: any) => (
                                  <span
                                    key={role.id}
                                    className="badge bg-primary me-1"
                                  >
                                    {role.name}
                                  </span>
                                ))}
                              </td>
                              <td>
                                {/* ACTION */}
                                <div className="d-flex gap-3">
                                  {(item.user_roles.length === 0 ||
                                    item.user_roles.some(
                                      (role) => role.name !== "ENTITY_ROLE"
                                    )) && (
                                    <>
                                      {/* EDITAR */}
                                      <PermissionWrapper action={"US0003"}>
                                        <Link
                                          className="text-success"
                                          to={"#!"}
                                          style={{ fontSize: "25px" }}
                                        >
                                          <i
                                            className="bx bxs-edit-alt"
                                            onClick={() =>
                                              handleEditUser(item.id)
                                            }
                                          ></i>
                                        </Link>
                                      </PermissionWrapper>

                                      {/* ELIMINAR */}
                                      <PermissionWrapper action={"US0004"}>
                                        <Link
                                          className="text-danger"
                                          to={"#!"}
                                          style={{ fontSize: "25px" }}
                                        >
                                          <i
                                            className={
                                              item.is_active
                                                ? "bx bxs-trash-alt"
                                                : "mdi mdi-reload"
                                            }
                                            onClick={() =>
                                              onClickDelete(item.id)
                                            }
                                          />
                                        </Link>
                                      </PermissionWrapper>
                                    </>
                                  )}
                                </div>
                              </td>
                            </tr>
                          ))}
                        </tbody>
                      </Table>

                      {/* PAGINACION */}
                      <div
                        className="pagination"
                        style={{ marginTop: "20px", textAlign: "center" }}
                      >
                        <button
                          className="btn btn-success btn-rounded mb-2 "
                          onClick={() =>
                            setCurrentPage((prev) => Math.max(prev - 1, 1))
                          }
                          disabled={currentPage === 1}
                          style={{ marginRight: "10px" }}
                        >
                          Prev
                        </button>
                        {Array.from({ length: totalPages }, (_, i) => (
                          <button
                            className="btn btn-danger btn-rounded mb-2 "
                            key={i + 1}
                            onClick={() => setCurrentPage(i + 1)}
                            style={{
                              margin: "0 5px",
                              fontWeight:
                                currentPage === i + 1 ? "bold" : "normal",
                            }}
                          >
                            {i + 1}
                          </button>
                        ))}
                        <button
                          className="btn btn-success btn-rounded mb-2 "
                          onClick={() =>
                            setCurrentPage((prev) =>
                              Math.min(prev + 1, totalPages)
                            )
                          }
                          disabled={currentPage === totalPages}
                          style={{ marginLeft: "10px" }}
                        >
                          Next
                        </button>
                      </div>
                    </div>
                  </CardBody>
                </Card>
              )}

              {/* MODAL PARA AGREAGR Y EDITAR */}
              {isEdit ? (
                <Modal isOpen={modalEdit} toggle={toggleEdit}>
                  <ModalHeader toggle={toggleEdit} tag="h4">
                    {" "}
                    {"Edit User"}
                  </ModalHeader>
                  <ModalBody>
                    <Form
                      onSubmit={(e) => {
                        e.preventDefault();
                        validationEdit.handleSubmit();
                        return false;
                      }}
                    >
                      <Row>
                        <Col xs={12}>
                          {/* NOMBRE */}
                          <div className="mb-3">
                            <Label>Name</Label>
                            <Input
                              name="name"
                              type="text"
                              onChange={validationEdit.handleChange}
                              onBlur={validationEdit.handleBlur}
                              value={validationEdit.values.name || ""}
                              invalid={
                                validationEdit.touched.name &&
                                validationEdit.errors.name
                                  ? true
                                  : false
                              }
                            />
                            {validationEdit.touched.name &&
                            validationEdit.errors.name ? (
                              <FormFeedback type="invalid">
                                {validationEdit.errors.name}
                              </FormFeedback>
                            ) : null}
                          </div>

                          {/* APELLIDOS */}
                          <div className="mb-3">
                            <Label>Apellidos</Label>
                            <Input
                              name="last_name"
                              type="text"
                              onChange={validationEdit.handleChange}
                              onBlur={validationEdit.handleBlur}
                              value={validationEdit.values.last_name || ""}
                              invalid={
                                validationEdit.touched.last_name &&
                                validationEdit.errors.last_name
                                  ? true
                                  : false
                              }
                            />
                            {validationEdit.touched.last_name &&
                            validationEdit.errors.last_name ? (
                              <FormFeedback type="invalid">
                                {validationEdit.errors.last_name}
                              </FormFeedback>
                            ) : null}
                          </div>

                          {/* Roles */}
                          <label className="form-label">Roles</label>
                          <Select
                            isMulti
                            name="colors"
                            defaultValue={rolesDataEdit.map((permiso) => ({
                              value: permiso.id,
                              label: permiso.name,
                            }))} // Convertimos los permisos existentes al formato de opciones
                            options={options}
                            placeholder="Seleccionar roles..."
                            className="basic-multi-select"
                            classNamePrefix="select"
                            closeMenuOnSelect={false}
                            onChange={handleChange}
                            styles={{
                              option: (base, { isSelected, isFocused }) => ({
                                ...base,
                                backgroundColor: isSelected
                                  ? "#3b82f6"
                                  : isFocused
                                  ? "#e9f5ff"
                                  : "white",
                                color: isSelected ? "white" : "black",
                                cursor: "pointer",
                                fontWeight: isSelected ? "bold" : "normal",
                                ":hover": {
                                  backgroundColor: isSelected
                                    ? "#1e40af"
                                    : "#e9f5ff",
                                  color: "black",
                                },
                              }),
                              multiValue: (base) => ({
                                ...base,
                                backgroundColor: "#3b82f6",
                                color: "white",
                                borderRadius: "5px",
                                padding: "2px 5px",
                              }),
                              multiValueLabel: (base) => ({
                                ...base,
                                color: "white",
                                fontWeight: "bold",
                              }),
                              multiValueRemove: (base) => ({
                                ...base,
                                color: "white",
                                ":hover": {
                                  backgroundColor: "#1e40af",
                                  color: "white",
                                },
                              }),
                            }}
                          />
                        </Col>
                      </Row>
                      <Row>
                        <Col>
                          <div className="text-end mt-3">
                            <Button
                              type="submit"
                              color="success"
                              className="save-user"
                            >
                              {" "}
                              {"Update"}{" "}
                            </Button>
                          </div>
                        </Col>
                      </Row>
                    </Form>
                  </ModalBody>
                </Modal>
              ) : (
                <Modal isOpen={modal} toggle={toggle}>
                  <ModalHeader toggle={toggle} tag="h4">
                    {" "}
                    {"Add User"}
                  </ModalHeader>
                  <ModalBody>
                    <Form
                      onSubmit={(e) => {
                        e.preventDefault();
                        validation.handleSubmit();
                        return false;
                      }}
                    >
                      <Row>
                        <Col xs={12}>
                          {/* NOMBRE */}
                          <div className="mb-3">
                            <Label>Name</Label>
                            <Input
                              name="name"
                              type="text"
                              onChange={validation.handleChange}
                              onBlur={validation.handleBlur}
                              value={validation.values.name || ""}
                              invalid={
                                validation.touched.name &&
                                validation.errors.name
                                  ? true
                                  : false
                              }
                            />
                            {validation.touched.name &&
                            validation.errors.name ? (
                              <FormFeedback type="invalid">
                                {validation.errors.name}
                              </FormFeedback>
                            ) : null}
                          </div>

                          {/* APELLIDOS */}
                          <div className="mb-3">
                            <Label>Apellidos</Label>
                            <Input
                              name="last_name"
                              type="text"
                              onChange={validation.handleChange}
                              onBlur={validation.handleBlur}
                              value={validation.values.last_name || ""}
                              invalid={
                                validation.touched.last_name &&
                                validation.errors.last_name
                                  ? true
                                  : false
                              }
                            />
                            {validation.touched.last_name &&
                            validation.errors.last_name ? (
                              <FormFeedback type="invalid">
                                {validation.errors.last_name}
                              </FormFeedback>
                            ) : null}
                          </div>

                          {/* CORREO */}
                          <div className="mb-3">
                            <Label>Email</Label>
                            <Input
                              name="email"
                              label="Email"
                              type="email"
                              onChange={validation.handleChange}
                              onBlur={validation.handleBlur}
                              value={validation.values.email || ""}
                              invalid={
                                validation.touched.email &&
                                validation.errors.email
                                  ? true
                                  : false
                              }
                            />
                            {validation.touched.email &&
                            validation.errors.email ? (
                              <FormFeedback type="invalid">
                                {" "}
                                {validation.errors.email}{" "}
                              </FormFeedback>
                            ) : null}
                          </div>

                          {/* Gender */}
                          <div className="mb-3">
                            <Label className="form-label">Gender</Label>
                            <Input
                              type="select"
                              name="gender_id"
                              onChange={validation.handleChange}
                              onBlur={validation.handleBlur}
                              value={validation.values.gender_id || ""}
                              invalid={
                                validation.touched.gender_id &&
                                validation.errors.gender_id
                                  ? true
                                  : false
                              }
                            >
                              <option value="" selected disabled>
                                Select gender
                              </option>
                              {gendersType.map((gender) => (
                                <option key={gender.id} value={gender.id}>
                                  {gender.name}
                                </option>
                              ))}
                            </Input>
                            {validation.touched.gender_id &&
                              validation.errors.gender_id && (
                                <FormFeedback>
                                  {validation.errors.gender_id}
                                </FormFeedback>
                              )}
                          </div>

                          {/* Country */}
                          <div className="mb-3">
                            <Label className="form-label">Pais</Label>
                            <Input
                              type="select"
                              name="country_id"
                              onChange={validation.handleChange}
                              onBlur={validation.handleBlur}
                              value={validation.values.country_id || ""}
                              invalid={
                                validation.touched.country_id &&
                                validation.errors.country_id
                                  ? true
                                  : false
                              }
                            >
                              <option value="" selected disabled>
                                Select gender
                              </option>
                              {countries.map((country: any) => (
                                <option key={country.id} value={country.id}>
                                  {country.name}
                                </option>
                              ))}
                            </Input>
                            {validation.touched.country_id &&
                              validation.errors.country_id && (
                                <FormFeedback>
                                  {validation.errors.country_id}
                                </FormFeedback>
                              )}
                          </div>

                          {/* Roles */}
                          <label className="form-label">Roles</label>
                          <Select
                            isMulti
                            name="colors"
                            options={options}
                            placeholder="Seleccionar roles..."
                            className="basic-multi-select"
                            classNamePrefix="select"
                            closeMenuOnSelect={false}
                            onChange={handleChange}
                            styles={{
                              menuList(base, props) {
                                return {
                                  ...base,
                                  height: "200px",
                                  backgroundColor: "white",
                                  color: "black",
                                };
                              },
                            }}
                          />

                          {/* Contrasena */}
                          <div className="mt-3">
                            <Label>Contraseña</Label>
                            <Input
                              name="password"
                              label="password"
                              type="text"
                              onChange={validation.handleChange}
                              onBlur={validation.handleBlur}
                              value={validation.values.password || ""}
                              invalid={
                                validation.touched.password &&
                                validation.errors.password
                                  ? true
                                  : false
                              }
                            />
                            {validation.touched.password &&
                            validation.errors.password ? (
                              <FormFeedback type="invalid">
                                {" "}
                                {validation.errors.password}{" "}
                              </FormFeedback>
                            ) : null}
                          </div>
                        </Col>
                      </Row>
                      <Row>
                        <Col>
                          <div className="text-end mt-3">
                            <Button
                              type="submit"
                              color="success"
                              className="save-user"
                            >
                              {" "}
                              {!!isEdit ? "Update" : "Add"}{" "}
                            </Button>
                          </div>
                        </Col>
                      </Row>
                    </Form>
                  </ModalBody>
                </Modal>
              )}
            </Col>
          </Row>
        </Container>
      </div>
      <ToastContainer />
    </React.Fragment>
  );
};

export default withRouter(UserSystem);
